// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "get-upload-token";

const uploadTokenDataSchema = z.object({
  signedUrl: z.string(),
  token: z.string(),
  path: z.string(),
});

export const getUploadTokenResponseSchema = z
  .object({
    data: z.array(uploadTokenDataSchema.nullable()),
  })
  .strict();

const allowedFileTypes = z.enum([".pdf", ".png", ".jpg", ".jpeg"]);

const fileUploadItemSchema = z.object({
  claimDetailId: z.string(),
  fileName: z.string(),
});

export const getUploadTokenParamsSchema = z
  .object({
    filesToUpload: z.array(fileUploadItemSchema),
  })
  .strict();




export type UploadTokenData = z.infer<typeof uploadTokenDataSchema>;

export type GetUploadTokenResponse = z.infer<
  typeof getUploadTokenResponseSchema
>;

export type AllowedFileType = z.infer<typeof allowedFileTypes>;

export type FileUploadItem = z.infer<typeof fileUploadItemSchema>;

export type GetUploadTokenParams = z.infer<typeof getUploadTokenParamsSchema>;




// receiver/get-upload-token endpoint
export function getUploadToken(
  params: z.input<typeof getUploadTokenParamsSchema>
): Promise<GetUploadTokenResponse> {
  return requestHandler(
    "receiver/get-upload-token",
    params,
    getUploadTokenResponseSchema,
  );
}

